/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Module} from 'vuex';
import {RootState} from '@/store/types';
import {VoteStateInterface} from '@/store/modules/vote/types';
import {actions} from '@/store/modules/vote/actions';


export const state: VoteStateInterface = {
    vote: -1,
};

const namespaced: boolean = true;

export const voteStateModule: Module<VoteStateInterface, RootState> = {
    namespaced,
    state,
    actions,
};
